import React from 'react'
import styled from "styled-components"
import {Link} from "gatsby"
import {convertImgSrc,convertLink} from "../functions"
var Image = styled.img `
    top: 0;
    height: 100%;
    width: 100%;
    border-radius: 8px;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: .3s ease-in-out;
    transition: .3s ease-in-out;

`

var AirlineFacilityImage = styled.img `
    top: 0;
    height: 80%;
    width: 80%;
    border-radius: 8px;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: .3s ease-in-out;
    transition: .3s ease-in-out;

`

var Bottom = styled.div `
    position: absolute;
    bottom: 0;
    width:100%;
    height:10%;
    background:rgba(225,0,0,.8);
    color:white;
    border-radius: 0 0px 8px 8px;
    display:flex;
    justify-content:center;
    align-items:center;

`

var Wrapper = styled.div `
position: relative;
height:270px;
width:90%;
@media screen and (min-width:320px) and (max-width:375px){
        width: 90%;
        height: 230px;
}
@media screen and (max-width:700px) and (min-width:415px){
        width: 225px;
    }
/* @media screen and (min-width:701px){
    width: 60%;
} */
`

var AirlineFacilityWrapper = styled.div `
position: relative;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
height:270px;
width:90%;
border: 1px solid rgba(225,0,0,.8);
border-radius: 10px;
@media screen and (min-width:320px) and (max-width:375px){
        width: 90%;
        height: 230px;
}
@media screen and (max-width:700px) and (min-width:415px){
        width: 225px;
    }
/* @media screen and (min-width:701px){
    width: 60%;
} */
`

var Boxhover = styled.div`
    position: relative;
    width:90%;
 `

function convertURL(url){
    if(url!="" || url!=null)
    var result = url.split("https://www.airasia.com/flights");
    // console.log("result[result.length-1]", result[result.length-1])
      return result[result.length-1]; 
     
  }


export default function CityCard(props) {
    //console.log("card",props)
    var title = props.city.match(/>.*</)
    title = title?title[0].slice(1,-1):props.city
    var baseURL = convertURL(props.link.href)
    return (
        <Link to={convertLink(baseURL)}>
        <Boxhover>
        <Wrapper >
            <Image src={convertImgSrc(props.image)} alt={title}/>
            <Bottom>
                <span>{title}</span>
            </Bottom>

        </Wrapper>
        </Boxhover>
        </Link>
    )
}

export function AirlineFacilityCard(props) {
    //console.log("card",props)
    var title = props.city.match(/>.*</)
    title = title ? title[0].slice(1, -1) : props.city
    var baseURL = convertURL(props.link.href)
    return (
        <Link to={convertLink(baseURL)}>
            <Boxhover>
                <AirlineFacilityWrapper >
                    <AirlineFacilityImage src={convertImgSrc(props.image)} alt={title} />
                    <Bottom>
                        <span>{title}</span>
                    </Bottom>

                </AirlineFacilityWrapper>
            </Boxhover>
        </Link>
    )
}

